var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNeutralEmoticon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 48C37.2546 48 48 37.2546 48 24C48 10.7454 37.2546 0 24 0C10.7454 0 0 10.7454 0 24C0 37.2546 10.7454 48 24 48Z",
    fill: "#FF5C00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2669 19.8905C14.2669 22.5285 12.1289 24.6696 9.48776 24.6696C6.84666 24.6696 4.70862 22.5316 4.70862 19.8905C4.70862 17.2494 6.84972 15.1113 9.48776 15.1113C12.1258 15.1113 14.2669 17.2524 14.2669 19.8905Z",
    fill: "#1C1C1C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.34973 18.0397C9.34973 18.8157 8.7209 19.4446 7.94482 19.4446C7.16875 19.4446 6.53992 18.8157 6.53992 18.0397C6.53992 17.2636 7.16875 16.6348 7.94482 16.6348C8.7209 16.6348 9.34973 17.2636 9.34973 18.0397Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8895 20.2551C10.8895 20.703 10.5276 21.0649 10.0797 21.0649C9.63186 21.0649 9.2699 20.703 9.2699 20.2551C9.2699 19.8073 9.63186 19.4453 10.0797 19.4453C10.5276 19.4453 10.8895 19.8073 10.8895 20.2551Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2884 19.8905C43.2884 22.5285 41.1473 24.6696 38.5092 24.6696C35.8712 24.6696 33.7301 22.5316 33.7301 19.8905C33.7301 17.2494 35.8712 15.1113 38.5092 15.1113C41.1473 15.1113 43.2884 17.2524 43.2884 19.8905Z",
    fill: "#1C1C1C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3682 18.0397C38.3682 18.8157 37.7393 19.4446 36.9633 19.4446C36.1872 19.4446 35.5583 18.8157 35.5583 18.0397C35.5583 17.2636 36.1872 16.6348 36.9633 16.6348C37.7393 16.6348 38.3682 17.2636 38.3682 18.0397Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M39.908 20.2551C39.908 20.703 39.546 21.0649 39.0981 21.0649C38.6503 21.0649 38.2883 20.703 38.2883 20.2551C38.2883 19.8073 38.6503 19.4453 39.0981 19.4453C39.546 19.4453 39.908 19.8073 39.908 20.2551Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6196 27.288C28.8313 29.6837 26.5951 31.3309 24.0797 31.3953C21.5705 31.4598 19.227 29.8401 18.3711 27.4874C18.2331 27.107 17.8711 26.8524 17.454 26.9659C17.0859 27.0671 16.7945 27.4996 16.9325 27.8831C18.0276 30.8923 20.8619 32.9138 24.0767 32.8861C27.2668 32.8585 30.0705 30.6806 31.0552 27.6837C31.3558 26.7665 29.9172 26.3769 29.6165 27.288",
    fill: "#1C1C1C"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9203 28.7431C12.9203 30.0866 11.4571 31.1756 9.65033 31.1756C7.84358 31.1756 6.37732 30.0866 6.37732 28.7431C6.37732 27.3995 7.84358 26.3105 9.65033 26.3105C11.4571 26.3105 12.9203 27.3995 12.9203 28.7431Z",
    fill: "#FFD525"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6196 28.7431C41.6196 30.0866 40.1564 31.1756 38.3497 31.1756C36.5429 31.1756 35.0767 30.0866 35.0767 28.7431C35.0767 27.3995 36.5429 26.3105 38.3497 26.3105C40.1564 26.3105 41.6196 27.3995 41.6196 28.7431Z",
    fill: "#FFD525"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeutralEmoticon);
export default __webpack_public_path__ + "static/media/neutral-emoticon.7f4fd825.svg";
export { ForwardRef as ReactComponent };